export type PerTripDefinitionSetting = Array<{ tripDefinition: string; value: number }>;

export function resolvePerTripDefinitionValue(
    setting: PerTripDefinitionSetting | number | undefined | null,
    tripDefinitionId: string | null | undefined,
    fallback = 0,
): number {
    if (typeof setting === 'number') {
        return setting;
    }

    if (!Array.isArray(setting) || setting.length === 0 || !tripDefinitionId) {
        return fallback;
    }

    const match = setting.find((item) => item.tripDefinition === tripDefinitionId);
    return match?.value ?? fallback;
}
